module.exports = __webpack_public_path__ + "media/my_images/top/arrow-red-c37b88f74b97d6c32276eaff4b7a240c.svg";